import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { useTranslation, Trans } from "react-i18next";
import ScrollAnimation from "./animations/scroll-animation";
import SignUpButton from "../../SignUpButton";

const TokenVestingSections = () => {
  const { t } = useTranslation();

  const data = useStaticQuery(graphql`
    query {
      imageTokenDistribution: file(
        relativePath: { eq: "images/vesting-schedule.png" }
      ) {
        publicURL
      }
      imageVestingSchedule: file(
        relativePath: { eq: "images/token-distribution.png" }
      ) {
        publicURL
      }
    }
  `);

  return (
    <>
      <ScrollAnimation
        imageTokenDistribution={data.imageTokenDistribution}
        imageVestingSchedule={data.imageVestingSchedule}
      />
      <div id="token-vesting-sections" className="d-block d-md-none">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-6 animation-placeholder">
              {/* <Waypoint onEnter={()=>setRenderLottie(true)} />{ renderLottie && <TokenDistribution /> } */}
              {/* <TokenDistribution /> */}
              <img
                src={data.imageTokenDistribution.publicURL}
                alt="Token Distribution"
                className="img-fluid"
              />
            </div>
            <div className="col-12 col-lg-6 d-flex align-items-center section-1">
              <div>
                <h2 className="text-center text-md-left">
                  {t("zmt.tokenVesting.token.title")}
                </h2>
                <p className="text-center text-md-left">
                  <Trans
                    i18nKey="zmt.tokenVesting.token.description"
                    components={[<span>200M ZMT</span>]}
                  />
                </p>
                <div className="my-5">
                  <SignUpButton className="button button-secondary button-buy">
                    {t("zmt.btnOnBoard")} &#8594;
                  </SignUpButton>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-6 animation-placeholder">
              <img
                src={data.imageVestingSchedule.publicURL}
                alt="Vesting Schedule"
                className="img-fluid"
              />
            </div>
            <div className="col-12 col-lg-6 d-flex align-items-center section-2">
              <div>
                <h2 className="text-center text-md-left">
                  <Trans
                    i18nKey="zmt.tokenVesting.vesting.title"
                    components={[]}
                  />
                </h2>
                <p className="text-center text-md-left">
                  <Trans
                    i18nKey="zmt.tokenVesting.vesting.description"
                    components={[<span>4 year period</span>]}
                  />
                </p>
                <div className="my-5">
                  <SignUpButton className="button button-secondary button-buy">
                    {t("zmt.btnOnBoard")} &#8594;
                  </SignUpButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TokenVestingSections;
